import { localizer } from '@skype/bew-localization';
import Config from 'config';
import * as React from 'react';
import { AriaContextConsumer } from 'src/ts/contexts/AriaContext';
import { logger } from '../../helpers/LoggerHelper';
import { hipConfig, IHipObject } from './HipObject';

export interface CaptchaSolution {
    solution: string; // "dhjdprwgyn",
    token: string; // "EUS.11fee09f92674cd79348179704b999ce",
    type: 'visual' | 'audio';
}

export interface CaptchaProps {
    onLoad: () => void;
}

const rand = Math.round(Math.random() * 10000000);
export class Captcha extends React.PureComponent<CaptchaProps, React.StatelessComponent>  {
    private _hipObject: IHipObject;
    constructor(props: CaptchaProps) {
        super(props);

        this.state = {};
        hipConfig.postLoad = this._onLoad;
        (window as any).WLSPHIP0 = hipConfig;
        this._hipObject = (window as any).WLSPHIP0;
    }

    reloadHip() {
        this._hipObject.reloadHIP();
    }

    verify(callback: (solution: CaptchaSolution, error?: string) => void) {
        this._hipObject.verify((solution, token, hipObject) => {
            hipObject.clientValidation();
            callback({
                solution,
                token,
                type: hipObject.type,
            }, this._hipObject.getError());
        }, this._hipObject);
    }

    render() {
        return <>
            <AriaContextConsumer>{ (ariaContext) =>
                <div id='captcha-container' className='captcha-container' ref={ () => {
                    ariaContext.announce({ assertive: true, text: localizer.getString('Common.a11y_announce_captcha') });
                } }>
                    <div id='captchaImage'></div>
                    <div id='captchaScript' ref={ this._setRef }></div>
                    <div id='captchaError' className='captcha__error'></div>
                </div>
            }</AriaContextConsumer>
        </>;
    }

    private _onLoad = () => {
        this.props.onLoad();
        this._hipObject.setFocus();
    }

    private _setRef = (element: HTMLElement | null) => {
        if (element) {
            const script = document.createElement('script');
            script.src = Config.urls.api.captcha(localizer.getLocale(), logger.getSessionId(), rand.toString());
            script.async = true;
            script.defer = true;
            element.appendChild(script);
        }
    }
}
